 import React, { useState } from "react";
import "../Style/dealershipSection.css";
import { FaHandshake, FaBullhorn, FaChartLine, FaAward } from "react-icons/fa";

const topics = [
  { icon: <FaHandshake />, title: "Reliable Supply", desc: "Reliable product supply and quality assurance" },
  { icon: <FaBullhorn />, title: "Marketing Support", desc: "Marketing and promotional support" },
  { icon: <FaChartLine />, title: "Business Development", desc: "Business development assistance" },
  { icon: <FaAward />, title: "Long-term Partnership", desc: "Long-term partnership opportunities" },
];

const DealershipSection = () => {

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const sendEmail = async (e) => {
    e.preventDefault();

    const response = await fetch("http://localhost:5000/send-email", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(formData),
    });

    const data = await response.json();

    if (data.success) {
      alert("Message Sent Successfully!");
    } else {
      alert("Error! Please Try Again.");
    }

    setFormData({
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      message: "",
    });
  };

  return (
    <section className="dealership-section">
      <div className="container">
        
        {/* Left Content */}
        <div className="dealership-left">
          <h2>Dealership and Distributor Opportunities Sharda Industries</h2>

          <p style={{ textAlign: "justify" }}>
            Are you looking to start your own business with low investment and high returns? Sharda 
Industries offer an excellent opportunity to become our dealer or distributor and earn up to 25% profit with minimal investment.

We are expanding our network and are now offering dealership opportunities across all of India, with Madhya Pradesh being our primary target region to begin this expansion.
Our manufacturing unit is located in Sagar, and our corporate office is based in Bhopal and Indore ensuring smooth coordination, timely delivery, and strong support for all our partners.

          </p>
          <p>At Sharda Industries, we believe in growing together. We provide complete guidance and support to our dealers and distributors, including:</p>

          <div className="topics-list">
            {topics.map((topic, idx) => (
              <div key={idx} className="topic-item">
                <div className="topic-heading">
                  <span className="topic-icon">{topic.icon}</span>
                  <h4>{topic.title}</h4>
                </div>
                <p>{topic.desc}</p>
              </div>
            ))}
          </div>

          <p style={{ textAlign: "justify" }}> <br />
            With a focus on quality, trust, and transparency, Sharda Industries has built a strong reputation in the market. Now, we invite you to become a part of our success story.
Take the first step towards your entrepreneurial journey with Sharda Industries - where low investment meets high profit potential.

          </p>
        </div>

        {/* Right Form */}
        <div className="dealership-right">
          <h3>Contact Us</h3>

          <form onSubmit={sendEmail}>
            <div className="form-row">
              <input type="text" name="firstName" placeholder="First Name" required value={formData.firstName} onChange={handleChange} />
              <input type="text" name="lastName" placeholder="Last Name" required value={formData.lastName} onChange={handleChange} />
            </div>

            <div className="form-row">
              <input type="email" name="email" placeholder="Your Email" required value={formData.email} onChange={handleChange} />
              <input type="tel" name="phone" placeholder="Phone Number" required value={formData.phone} onChange={handleChange} />
            </div>

            <textarea name="message" placeholder="Your Message" rows="5" required value={formData.message} onChange={handleChange}></textarea>

            <button type="submit">Submit</button>
          </form>

        </div>
      </div>
    </section>
  );
};

export default DealershipSection;
